module.exports = __webpack_public_path__ + "img/logo.1e61b134.png";